module.exports = __webpack_public_path__ + "img/hr-tree-06-a-leaves.83d97c5c.png";